import styled from 'styled-components'

/** Nowrap action row; Open Tab collapses to icon-sm when the card is narrow. */
export const RevisionCardActions = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;
  margin-top: auto;
  container-type: inline-size;

  & > * {
    flex-shrink: 0;
  }

  & [data-open-tab='icon'] {
    display: none;
  }

  @container (max-width: 14rem) {
    & [data-open-tab='full'] {
      display: none;
    }

    & [data-open-tab='icon'] {
      display: inline-flex;
    }
  }
`
